export const WeChatApplicationType = {
    List: [
        {label: "WECHAT_APPLICATION_TYPE_OFFICIAL", value: "01"},
        {label: "WECHAT_APPLICATION_TYPE_APPLET", value: "02"}
    ],
    Map: new Map<string, string>([
        ['01', 'WECHAT_APPLICATION_TYPE_OFFICIAL'],
        ['02', 'WECHAT_APPLICATION_TYPE_APPLET'],
    ]),
    Enum: {
        Official: '01',
        Applet: "02"
    }
};